



























































































































import FleetManagerTreeDialog from "@/components/fleet/FleetManagerTreeDialog.vue";
import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import Notifications from "@/components/thg/Notifications.vue";
import ErrorCard from "@/components/utility/ErrorCard.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { ITableWrapperHeader } from "@/lib/types/tableWrapper";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { dottedDateWithDayAndDer, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import { IInvoiceTotalsByCurrency } from "@/models/invoice-aggregation.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IReport } from "@/models/report.entity";
import { ConfigModule } from "@/store/modules/config";
import { DamageFleetModule } from "@/store/modules/fleet/damage-fleet.store";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { ReportModule } from "@/store/modules/report.store";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";
import { debounce } from "debounce";
import { Component, Vue } from "vue-property-decorator";
import { REPORT_COLOR_BY_STATUS } from "../user/MyDamageView.vue";

@Component({
  components: {
    LayoutReportWithBanner,
    Notifications,
    MyDamageDetailSideCard,
    PaginatedTable,
    FleetManagerTreeDialog,
    ErrorCard,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate,
    dottedDateWithDayAndDer
  }
})
export default class FleetDamageView extends Vue {
  readonly store = DamageFleetModule;

  CurrencyEnum = CurrencyEnum;
  formatCurrency = formatCurrency;

  isDialog = false;

  loading = false;
  isError = false;
  selectedId: string | null = null;
  updateTableKey = "";

  get color() {
    return ConfigModule.color.palette;
  }

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: $t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetAnalyticsView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: $t("common.nouns.report"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetDamageView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get chips(): IAction[] {
    return [
      {
        text: `${DamageFleetModule.totalItems} ${$t("common.nouns.report")}`,
        key: "fahrzeuge",
        icon: "mdi-car-wrench"
      }
    ];
  }

  get actions(): IAction[] {
    return [
      {
        text: $t("views.report.fleet.FleetAnalyticsView.selectionDialog.openFleetTree").toString(),
        key: "fleet",
        exec: () => ((this.$refs.dialog as unknown) as IDialog)?.open(),
        disabled: this.selectedFleetIds.length <= 1
      }
    ].filter(a => !a.disabled);
  }

  get predefinedFilter(): PredefinedFilterType[] {
    return [];
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get selectedFleetIds() {
    return FleetManagerModule.selectedFleetIds;
  }

  get fleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get currentReport() {
    return DamageFleetModule.currentReport;
  }

  get colorByStatus() {
    return REPORT_COLOR_BY_STATUS;
  }

  get reportDownloadHeaders(): Map<string, string> {
    const headers = new Map<string, string>();

    headers.set("createdAt", this.$t("objects.timestamp.created").toString());
    headers.set("claimNumber", this.$t("objects.report.leasing.claimNumber").toString());
    headers.set("numberplate", this.$t("objects.report.numberplate").toString());
    headers.set("companyName", this.$t("common.nouns.company").toString());
    headers.set("fleet", this.$t("common.nouns.fleet").toString());
    headers.set("costCenter", this.$t("objects.vehicle.costCenter").toString());
    headers.set("customerName", this.$t("objects.report.customerName").toString());
    headers.set("status", this.$t("objects.report.status").toString());
    headers.set("accidentDate", this.$t("report.accidentDetails.date").toString());
    headers.set("coverageType", this.$t("objects.report.coverageType").toString());
    headers.set("damageType", this.$t("objects.report.damageType").toString());
    headers.set("damageArea", this.$t("components.partner.PartnerReportDetailInfoCard.damageLocator.title").toString());
    headers.set("tripType", this.$t("objects.report.tripType").toString());
    headers.set("workShopCompany", this.$t("enums.CompanyServiceEnum.WORKSHOP").toString());
    headers.set("repairStatus", this.$t("objects.report.repair.status").toString());
    headers.set("repairStartDate", this.$t("objects.clearance.repairStart").toString());
    headers.set("repairEndDate", this.$t("objects.clearance.repairEnd").toString());
    headers.set("inboundInvoiceTotals", this.$t("objects.report.invoiceInboundAggregation").toString());
    headers.set(
      "selfContributionInvoiceTotals",
      this.$t("objects.report.invoiceSelfContributionAggregation").toString()
    );

    return headers;
  }

  get reportDownloadConfig() {
    return {
      transform: (item: IReport): Record<string, any> => {
        return {
          createdAt: item.timestamps?.created ? new Date(item.timestamps.created) : undefined,
          status: item.status || $t(`enums.ProgressStatusEnum.${item.progressStatus}`),
          claimNumber: item.claimNumber,
          numberplate: item.numberplate,
          companyName: item.companyName,
          fleet: item.fleet?.title,
          costCenter: item.costCenter,
          customerName: item.customerName,
          accidentDate: item.accidentDetails?.date ? new Date(item.accidentDetails.date) : undefined,
          coverageType: item.coverageType ? this.$t(`enums.CoverageTypeEnum.${item.coverageType}`) : "",
          damageType: item.damageType ? this.$t(`enums.DamageTypeEnum.${item.damageType}`) : "",
          damageArea: this.getDamageAreas(item),
          tripType: item.tripType ? this.$t(`enums.TripTypeEnum.${item.tripType}`) : "",
          workShopCompany: item.workShopCompany?.company,
          repairStatus: item.repair?.status ? this.$t(`enums.RepairStatusEnum.${item.repair.status}`) : "",
          repairStartDate: item.repair?.startDate ? new Date(item.repair.startDate) : undefined,
          repairEndDate: item.repair?.endDate ? new Date(item.repair.endDate) : undefined,
          inboundInvoiceTotals: (item.invoiceInboundAggregation?.totals ?? [])
            ?.map(total => formatCurrency(total.subtotal, total.currency as CurrencyEnum))
            .join(", "),
          selfContributionInvoiceTotals: (item.invoiceSelfContributionAggregation?.totals ?? [])
            ?.map(total => formatCurrency(total.subtotal, total.currency as CurrencyEnum))
            .join(", ")
        };
      },
      headers: this.reportDownloadHeaders
    };
  }

  get headers(): ITableWrapperHeader[] {
    return [
      {
        text: $t("objects.vehicle.timestamp.created"),
        align: "start",
        width: 120,
        value: "timestamp.created"
      },
      {
        text: $t("objects.report.status"),
        align: "start",
        width: 180,
        value: "status",
        mapping: (item: IReport) => (item?.status ? item.status : $t(`enums.ProgressStatusEnum.${item.progressStatus}`))
      },
      {
        text: $t("common.nouns.damage"),
        align: "start",
        value: "accidentDetails.date"
      },
      {
        text: $t("objects.report.invoiceInboundAggregation"),
        align: "end",
        value: "invoiceInboundAggregation.totals",
        width: 150,
        sort: this.sortInboundTotals,
        mapping: (item: IReport) =>
          (item?.invoiceInboundAggregation?.totals ?? [])
            ?.map(total => formatCurrency(total.subtotal, total.currency as CurrencyEnum))
            .join(", ") || "-"
      },
      {
        text: $t("objects.report.invoiceSelfContributionAggregation"),
        align: "end",
        value: "invoiceSelfContributionAggregation.totals",
        width: 150,
        sort: this.sortSelfTotals,
        mapping: (item: IReport) =>
          (item?.invoiceSelfContributionAggregation?.totals ?? [])
            ?.map(total => formatCurrency(total.subtotal, total.currency as CurrencyEnum))
            .join(", ") || "-"
      }
    ];
  }

  getDamageAreas(item: IReport) {
    const damages = item?.damage ?? [];

    return damages
      .map(damage =>
        $t(`components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.damages.${damage}`)
      )
      .join(", ");
  }

  get fleets() {
    return FleetManagerModule.fleets;
  }

  mounted() {
    const vehicleId = this.$route.query["vehicleId"] as string;

    if (vehicleId) {
      this.store.setFilters([new PageFilterElement({ key: "vehicleId", operation: "$eq", value: vehicleId })]);
    }
  }

  async openDetail(item: IReport) {
    this.$log.debug(item);

    if (!this.fleetId) {
      return;
    }

    this.loading = true;
    this.selectedId = null;

    try {
      const report = await DamageFleetModule.getOne({
        partnerId: this.partnerId,
        fleetId: this.fleetId,
        id: item._id
      });
      this.selectedId = report._id;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  debounceUpdateTable = debounce(this.updateTable, 200);
  updateTable() {
    // We filter using base query. The data access layer has to be cleared of all "old" results.
    this.store.reset();
    this.updateTableKey = FleetManagerModule.selectedFleetIds.join("_");
  }

  get tableSortDesc() {
    return (this.$refs.reportTable as PaginatedTable<any, any>)?.tableSortDesc;
  }

  private extractTotals(valueOrItem: any, path: "inbound" | "self"): IInvoiceTotalsByCurrency[] {
    if (Array.isArray(valueOrItem)) {
      return valueOrItem as IInvoiceTotalsByCurrency[];
    }

    const item = valueOrItem as IReport | undefined;
    if (!item) return [];

    return path === "inbound"
      ? item.invoiceInboundAggregation?.totals ?? []
      : item.invoiceSelfContributionAggregation?.totals ?? [];
  }

  private sumTotals(totals: IInvoiceTotalsByCurrency[]): number | null {
    if (!totals || totals.length === 0) return null;
    return totals.reduce((p, c) => p + (c?.subtotal ?? 0), 0);
  }

  private sortTotals(a: any, b: any, path: "inbound" | "self") {
    const desc = this.tableSortDesc ?? false;

    const totalsA = this.extractTotals(a, path);
    const totalsB = this.extractTotals(b, path);

    const sumA = this.sumTotals(totalsA);
    const sumB = this.sumTotals(totalsB);

    const emptyA = sumA === null;
    const emptyB = sumB === null;

    if (emptyA && emptyB) return 0;
    if (emptyA) return desc ? -1 : 1;
    if (emptyB) return desc ? 1 : -1;

    return (sumA as number) - (sumB as number);
  }

  sortInboundTotals(a: any, b: any) {
    return this.sortTotals(a, b, "inbound");
  }
  sortSelfTotals(a: any, b: any) {
    return this.sortTotals(a, b, "self");
  }
}
